import { useEffect, useRef } from 'react';

import { getAnonymousId } from 'utils/segment';

import { TagsIframe } from '../components/TagsIframe';
import { gtmSDK } from './GtmSDK';

export const GtmIframe = () => {
  const iframeRef = useRef(null);

  useEffect(() => {
    gtmSDK.registerIframe(iframeRef);

    const handleIframeLoad = () => {
      gtmSDK.initializeGtm();

      gtmSDK.sendEvent('fireDataLayerVariable', {
        variable: { segmentAnonymousId: getAnonymousId() },
      });
    };

    const iframeElement = iframeRef.current;
    if (iframeElement) {
      iframeElement.addEventListener('load', handleIframeLoad);
    }

    return () => {
      if (iframeElement) {
        iframeElement.removeEventListener('load', handleIframeLoad);
      }
    };
  }, []);

  return (
    <TagsIframe
      ref={iframeRef}
      title="Google Tag Manager Iframe"
      resourcePath={'/enrollment-client/gtm-analytics.html'}
    />
  );
};
